import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { PromoBar } from './components/PromoBar';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { QuickTestimonials } from './components/QuickTestimonials';
import { Problems } from './components/Problems';
import { SystemOverview } from './components/SystemOverview';
import { TheoryPractice } from './components/TheoryPractice';
import { Volumes } from './components/Volumes';
import { FitCheck } from './components/FitCheck';
import { Bonuses } from './components/Bonuses';
import { StickyBuyBar } from './components/StickyBuyBar';
import { LaunchUrgency } from './components/LaunchUrgency';
import { Offer } from './components/Offer';
import { TestimonialWall } from './components/TestimonialWall';
import { Guarantee } from './components/Guarantee';
import { FormatNotice } from './components/FormatNotice';
import { Faqs } from './components/Faqs';
import { Contact } from './components/Contact';
import { Comparison } from './components/Comparison';
import { FinalCall } from './components/FinalCall';
import { ClosingWords } from './components/ClosingWords';
import { SiteFooter } from './components/SiteFooter';
import { InlineCta } from './components/InlineCta';
import { PurchaseNotifications } from './components/PurchaseNotifications';
export function App() {
  useEffect(() => {
    document.documentElement.lang = 'pl';
    initMetaPixel();
  }, []);
  return <div lang="pl" className="w-full bg-night pb-[68px] font-sans text-cream sm:pb-0" data-id="element-0" data-mp="33m5c656pjo8v">
      <noscript data-id="element-1" data-mp="38m1e7yvuh5ls">
        <img height="1" width="1" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-2" data-mp="38li7zffk45nl" />
      </noscript>
      <PromoBar data-id="element-3" data-mp="nuraabrlit2m" />
      <Hero data-id="element-4" data-mp="nvanjf6awtab" />
      <SocialProofBar data-id="element-5" data-mp="nxww9i4xheu4" />
      <QuickTestimonials data-id="element-6" data-mp="sudnwmbc6bby" />
      <Problems data-id="element-7" data-mp="stkoy7imcq4d" />
      <InlineCta tone="wine-dark" label="Chcę skończyć z improwizacją" data-id="element-8" data-mp="st2iki28sviq" />
      <SystemOverview data-id="element-9" data-mp="35ovwnmbgyrj" />
      <TheoryPractice data-id="element-10" data-mp="34x3flo0nh5h" />
      <InlineCta tone="night-900" label="Chcę teorię + 50 ćwiczeń" data-id="element-11" data-mp="38ktgau95lfg" />
      <Volumes data-id="element-12" data-mp="3ubzvsgflbtha" />
      <InlineCta tone="night-900" label="Chcę wszystkie 6 tomów" data-id="element-13" data-mp="3ucje3y95kjvu" />
      <FitCheck data-id="element-14" data-mp="d3mmvivk99nu" />
      <Bonuses data-id="element-15" data-mp="d45tw4joadn3" />
      <InlineCta tone="night-900" label="Chcę pakiet z 6 bonusami" data-id="element-16" data-mp="d2l936n5u92f" />
      <LaunchUrgency data-id="element-17" data-mp="86w7kxrkyi3h" />
      <Offer data-id="element-18" data-mp="86cld4uwd7jn" />
      <TestimonialWall data-id="element-19" data-mp="83qhpgb4nc6p" />
      <InlineCta tone="night-900" label="Dołączam do 2 500+ pedagogów" data-id="element-20" data-mp="3gl4pnbwh7qhe" />
      <Guarantee data-id="element-21" data-mp="3gj1ru5p30t24" />
      <FormatNotice data-id="element-22" data-mp="3bmjqlfsyncuj" />
      <Faqs data-id="element-23" data-mp="3bn2z65wq0ovw" />
      <InlineCta tone="night" label="Tak, kupuję Arsenał" data-id="element-24" data-mp="3bnmh3mmdfd9x" />
      <Comparison data-id="element-25" data-mp="3qaxrvmaqat8z" />
      <InlineCta tone="night-900" label="Zacznij uczyć z systemem" data-id="element-26" data-mp="3qbfvx53mubrg" />
      <FinalCall data-id="element-27" data-mp="3lkhdnzz333lk" />
      <ClosingWords data-id="element-28" data-mp="3ljxw4kdcih82" />
      <InlineCta tone="night" label="Zdobądź Arsenał teraz" data-id="element-29" data-mp="3ljg1fs6c0b29" />
      <Contact data-id="element-30" data-mp="2xuwr773q1o7j" />
      <SiteFooter data-id="element-31" data-mp="2xud8vpa5sxsz" />
      <StickyBuyBar data-id="element-32" data-mp="2xtv7yfcjxveq" />
      <PurchaseNotifications data-id="element-33" data-mp="2xt27tx83m45k" />
    </div>;
}